import React from 'react';

import './style.scss';
import { Link } from "react-router-dom";

export const YourHelp = () => {
    return (
        <div className = 'wt wt-your-help'>
            <Link className = 'wt__container wt-your-help__container' to = '/your-help'>
                <h4 className = 'wt__title wt-your-help__title'>Твоя допомога</h4>
                <p className = 'wt__dc wt-your-help__desc'>
                    На цій сторінці ви знайдете телефони гарячих ліній, а також контакти ресурсів, де вам можуть надати необхідну допомогу
                </p>
            </Link>
        </div>
    );

};
